import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import AuthGuard from 'utils/route-guard/AuthGuard';

// render - UserFeedback
const UserFeedback = Loadable(lazy(() => import('pages/feedback-page')));
const Changelog = Loadable(lazy(() => import('pages/changelog')));
const TransactionUploads = Loadable(lazy(() => import('pages/transaction-uploads')));

// render - PropertyForm page
const PropertyForm = Loadable(lazy(() => import('pages/properties/PropertyForm')));
const PropertyInfo = Loadable(lazy(() => import('pages/properties/propertyInfo/PropertyInfoMain')));
const Profile = Loadable(lazy(() => import('pages/profile')));
const MyValuations = Loadable(lazy(() => import('pages/my-valuations')));
const PlanningZones = Loadable(lazy(() => import('pages/planning-zones')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <PropertyForm />
    },
    {
      path: 'feedback-page',
      element: <UserFeedback />
    },
    {
      path: 'changelog',
      element: <Changelog />
    },
    {
      path: 'transaction-uploads',
      element: <TransactionUploads />
    },
    {
      path: 'propertyform',
      element: <PropertyForm />
    },
    {
      path: 'myvaluations',
      element: <MyValuations />
    },
    {
      path: 'land-information',
      element: <PlanningZones />
    },
    {
      path: 'propertyinfo/:district/:municipality/:quarter/:block/:regist_no',
      element: <PropertyInfo />
    },
    {
      path: 'profile',
      element: <Profile />
    }
  ]
};

export default MainRoutes;
